import { NozzleType } from 'services/equipmentSets/constants';

const options: Record<string, any>[] = [
    {
        key: NozzleType.HV,
        text: NozzleType.HV,
        value: NozzleType.HV
    },
    {
        key: NozzleType.LV,
        text: NozzleType.LV,
        value: NozzleType.LV
    }
];

const weedSprayOptions: Record<string, any>[] = [
    {
        key: NozzleType.WEED_BOOM,
        text: 'Weed Boom',
        value: NozzleType.WEED_BOOM
    }
];

export { options, weedSprayOptions };
